<template>
    <div>
        <div class="d-flex justify-space-between mb-2">
            <div class="d-flex justify-center align-center">
                <div class="img_title_bill_retrospect_all">
                    <img src="@/assets/icon-restaurant-bill.png">
                </div>
                <h2 class="title_bill_retrospect_all">สร้างใบกำกับภาษี</h2>
            </div>

            <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect_all" height="50" width="20%"
                @click="$router.push('/billretrospectall')">
                ย้อนกลับ
            </v-btn>
        </div>
        <v-slide-x-reverse-transition>
            <!-- # <v-alert type="success" class="alert_success">ยกเลิกบิลเรียบร้อย</v-alert> -->
        </v-slide-x-reverse-transition>

        <v-card class="mb-5">
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false">
                <v-card-title style="font-size:20px;color:#000;font-weight:600;">
                    ข้อมูลใบเสร็จ
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3">
                            <p color="#6F6F6F" style="font-size:16px;font-weight:400;">เลขที่ใบเสร็จ : IV2024058000001
                            </p>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3">
                            <p color="#6F6F6F" style="font-size:16px;font-weight:400;">การชำระเงิน : เงินสด</p>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3">
                            <p color="#6F6F6F" style="font-size:16px;font-weight:400;">ยอดชำระ</p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
        </v-card>

        <v-card class="mb-5">
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false">
                <v-card-title style="font-size:20px;color:#000;font-weight:600;">
                    ข้อมูลลูกค้า
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field label="ชื่อลูกค้า" :rules="[v => !!v || 'กรุณากรอกชื่อลูกค้า']" required
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field label="เลขที่ผู้เสียภาษี" :rules="[v => !!v || 'กรุณากรอกเลขที่ผู้เสียภาษี']"
                                required outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-text-field label="ที่อยู่" :rules="[v => !!v || 'กรุณากรอกที่อยู่']" required
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-select label="ตำบล , อำเภอ , จังหวัด , รหัสไปรษณี" hide-details="auto"
                                :rules="[v => !!v || 'กรุณาเลือกโต๊ะ']" required outlined></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
        </v-card>
        <v-card class="mb-5">
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false">
                <v-card-title style="font-size:20px;color:#000;font-weight:600;">
                    การแสดงข้อมูลในใบเสร็จ
                </v-card-title>
                <v-card-text>
                    <v-radio-group row>
                        <v-radio label="รายการอาหาร" value="รายการอาหาร"></v-radio>
                        <v-radio label="ไม่แสดงรายการ เขียนรวมยอด “อาหารและเครื่องดื่ม”"
                            value="ไม่แสดงรายการ เขียนรวมยอด “อาหารและเครื่องดื่ม”"></v-radio>
                    </v-radio-group>
                </v-card-text>
            </div>
        </v-card>
        <div class="d-flex justify-center">
            <v-btn color="success" class="titlefont_poslist confirm_invoice_button" height="65">
                ยืนยันการสร้างใบกำกับภาษี
            </v-btn>
        </div>
    </div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/ZoftConnect_Logo_Black_for_Bill_150px.png";
export default {
    name: 'billretrospect',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
        }
    },
    methods: {

    },
    mounted() {
    },
    watch: {
    }
}
</script>
<style>
.confirm_invoice_button {
    width: 50% !important;
}

@media screen and (max-width: 768) {
    .confirm_invoice_button {
        width: 100% !important;
    }
}
</style>